import React from 'react';
import {
  Accordion, AccordionDetails, AccordionSummary,
  Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScrollableTable from '../common/ScrollableTable';

export interface EditHistoryRow {
  editSeq: number;
  editedAt: string;
  editReason: string;
  summary: string;
}

interface EditHistoryPanelProps {
  title: string;
  rows: EditHistoryRow[];
}

function formatDateTime(iso: string): string {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export const EditHistoryPanel: React.FC<EditHistoryPanelProps> = ({ title, rows }) => {
  if (rows.length === 0) return null;

  return (
    <Accordion sx={{ mt: 3 }} defaultExpanded={false} data-help-section="procurement.editHistory.panel">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <ScrollableTable>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell data-help="procurement.editHistory.col.no">#</TableCell>
                  <TableCell data-help="procurement.editHistory.col.at">Edited At</TableCell>
                  <TableCell data-help="procurement.editHistory.col.reason">Reason</TableCell>
                  <TableCell data-help="procurement.editHistory.col.summary">Summary</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.editSeq}>
                    <TableCell>{row.editSeq}</TableCell>
                    <TableCell>{formatDateTime(row.editedAt)}</TableCell>
                    <TableCell>{row.editReason}</TableCell>
                    <TableCell>{row.summary}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
        </ScrollableTable>
      </AccordionDetails>
    </Accordion>
  );
};

export default EditHistoryPanel;
